import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useWikiOverlay } from '../../contexts/WikiOverlayContext';
import { WikiHeader } from './WikiHeader';
import { WikiSidebar } from './WikiSidebar';
import { getWikiSections, getSearchablePages } from '../../lib/wiki/wikiData';

export function useActiveSlug() {
  const location = useLocation();
  if (location.pathname === '/wiki' || location.pathname === '/wiki/') {
    return 'index';
  }
  if (location.pathname.startsWith('/wiki/')) {
    return location.pathname.replace(/^\/wiki\/?/, '');
  }
  return '';
}

export function WikiShell({ children }) {
  const { language } = useLanguage();
  const activeSlug = useActiveSlug();
  const sections = getWikiSections(language);
  const searchPagesList = getSearchablePages(language);
  const { overlay } = useWikiOverlay();

  return (
    <div className="flex h-screen flex-col bg-white">
      <WikiHeader searchPages={searchPagesList} />
      <div className="flex min-h-0 flex-1">
        <WikiSidebar
          sections={sections}
          activeSlug={activeSlug}
          communityPages={overlay.newPages}
        />
        <main className="min-w-0 flex-1 overflow-y-auto">
          <div className="mx-auto max-w-4xl px-8 py-8">{children}</div>
        </main>
      </div>
    </div>
  );
}
